import { render, staticRenderFns } from "./title-table-goal-setting.component.vue?vue&type=template&id=4ef2bb1a&scoped=true"
import script from "./title-table-goal-setting.component.vue?vue&type=script&lang=ts"
export * from "./title-table-goal-setting.component.vue?vue&type=script&lang=ts"
import style0 from "./title-table-goal-setting.component.vue?vue&type=style&index=0&id=4ef2bb1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef2bb1a",
  null
  
)

export default component.exports